import { useContext, useEffect, useState } from "react";

import ApartmentIcon from "@material-ui/icons/Apartment";
import Grid from "@material-ui/core/Grid";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import CircularLoader from "../../components/loading/circularLoader";
import Title from "../../components/basics/Title";
import TabsErp from "../../components/tabs/TabsErp";
import { ClienteContext } from "../../context/ClienteContext";
import { ImutaveisContext } from "../../context/ImutaveisContext";
import TextFieldErp from "../../components/basics/TextFieldErp";
import SelectErp from "../../components/basics/SelectErp";
import ButtonErp from "../../components/basics/ButtonErp";
import Loading from "../../components/basics/Loading";
import useClienteController from "./ClienteController";
import MaskService from "../../utils/mask/maskService";
import ModalCertificado from "./ModalCertificado";
import "./Cliente.css";
import { findCertificadoCliente } from "../../repository/ERP/prouser/ClienteService";

export default function EdicaoCliente({ location }) {
  const [tabIndex, setTabIndex] = useState(0);
  const {
    handleSubmitEdit,
    handleCancel,

    handleTipoInscricao,
    handleNumInscricaoEstadual,
    handleNumInscricaoMunicipal,
    handleCcm,
    handleNome,
    handleEmail,

    handlePais,
    handleUf,
    handleCidade,
    handleLogradouro,
    handleComplemento,
    handleBairro,
  } = useClienteController();
  const { optionsPais, optionsEstado, optionsMunicipio } =
    useContext(ImutaveisContext);
  const {
    loading,
    setNumInscricao,
    setCep,
    setFile,
    setLoadingCheckbox,
    setChangeCertificate,
    setCheckboxCertificado,
    setPasswordCertificate,
  } = useContext(ClienteContext);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};

    let tipo = { descricao: "CNPJ" };
    if (row.cpfcnpj && row.cpfcnpj.replace(/[^0-9]+/g, "").length <= 11) {
      tipo = { descricao: "CPF" };
      handleTipoInscricao({ descricao: "CPF" });
    }

    setNumInscricao(
      MaskService.toMask(tipo.descricao.toLowerCase(), row.cpfcnpj)
    );

    handleNumInscricaoEstadual({
      target: { value: row.ie || "" },
    });
    handleNumInscricaoMunicipal({
      target: { value: row.inscricao_municipal || "" },
    });
    handleCcm({ target: { value: row.ccm || "" } });
    handleNome({ target: { value: row.apelido || "" } });
    handleEmail({ target: { value: row.email || "" } });

    setCheckboxCertificado({
      contador: row.usar_certificado_cliente === "0" ? true : false,
      cliente: row.usar_certificado_cliente === "1" ? true : false,
    });
  }, [
    setCheckboxCertificado,
    handleTipoInscricao,
    setNumInscricao,
    handleNumInscricaoEstadual,
    handleNumInscricaoMunicipal,
    handleCcm,
    handleNome,
    handleEmail,
    location,
  ]);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};

    if (!row.cpfcnpj) return;

    setChangeCertificate({});

    (async () => {
      try {
        setLoadingCheckbox(true);

        const result = await findCertificadoCliente(
          row.cpfcnpj.replace(/[^0-9]+/g, "")
        );

        if (result && result.success) {
          setFile({ b64: result.data.CertificadoDigital });
          setPasswordCertificate(result.data.CertificadoDigitalPass);
        } else {
          setFile(null);
          setPasswordCertificate("");
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoadingCheckbox(false);
      }
    })();
  }, [
    setFile,
    setPasswordCertificate,
    setLoadingCheckbox,
    setChangeCertificate,
    location,
  ]);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};

    setCep(MaskService.toMask("cep", row.cep || ""));

    handleLogradouro({ target: { value: row.endereco || "" } });

    handleComplemento({ target: { value: row.complemento || "" } });

    handleBairro({ target: { value: row.bairro || "" } });
  }, [handleBairro, setCep, handleComplemento, handleLogradouro, location]);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};
    if (row.idpais) {
      handlePais(optionsPais.find((opt) => opt.codigo === row.idpais));
    }
  }, [handlePais, optionsPais, location]);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};

    if (row.id_estado) {
      handleUf(optionsEstado.find((opt) => opt.id === row.id_estado) || null);
    }
  }, [handleUf, optionsEstado, location]);

  useEffect(() => {
    const row = location && location.state ? JSON.parse(location.state) : {};

    if (row.municipio_codigo) {
      handleCidade(
        optionsMunicipio.find((opt) => opt.codigo === row.municipio_codigo) ||
          null
      );
    }
  }, [handleCidade, optionsMunicipio, location]);

  const headers = [
    {
      label: "Dados cadastrais",
    },
    {
      label: "Endereço",
    },
  ];

  const children = [
    <TabDados key="0" />,
    <TabEndereco key="1" row={location.state} />,
  ];

  return (
    <>
      <Loading open={loading} />
      <div className="fluid-container">
        <div className="container">
          <Title titulo="Edição de Clientes" icon={ApartmentIcon} />
          <TabsErp
            headers={headers}
            children={children}
            tabIndex={tabIndex}
            onChange={(event, value) => {
              if (Number.isInteger(value)) setTabIndex(value);
            }}
          />
          <Grid
            container
            justify="flex-end"
            style={{
              background: "white",
              borderRadius: "0px 0px 10px 10px",
              padding: 10,
            }}
          >
            <ButtonErp cancel onClick={handleCancel} />
            <ButtonErp
              save
              onClick={() => handleSubmitEdit(location)}
              disabled={location && location.state ? false : true}
            />
          </Grid>
        </div>
      </div>
    </>
  );
}

function TabDados() {
  const {
    handleNumInscricao,
    handleTipoInscricao,
    handleNumInscricaoEstadual,
    handleNumInscricaoMunicipal,
    handleCcm,
    handleNome,
    handleEmail,
    handleChangeCheckContador,
    handleChangeCheckCliente,
  } = useClienteController();
  const {
    tipoInscricao,
    numInscricao,
    numInscricaoEstadual,
    numInscricaoMunicipal,
    ccm,
    nome,
    email,
    loadingCheckbox,
    checkboxCertificado,
    openModalCertificado,
    errors,
  } = useContext(ClienteContext);

  return (
    <>
      {openModalCertificado && <ModalCertificado />}
      <Grid
        container
        style={{
          background: "white",
          borderRadius: "10px 10px 0px 0px",
          padding: 10,
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={2} md={6} sm={6} xs={12}>
            <SelectErp
              disabled
              helperText={errors.tipoInscricao || ""}
              error={errors.tipoInscricao ? true : false}
              label="Tipo de Inscrição"
              lg={2}
              value={tipoInscricao}
              onChange={handleTipoInscricao}
              optionsList={[{ descricao: "CNPJ" }, { descricao: "CPF" }]}
              descriptionField="descricao"
            />
          </Grid>

          <Grid item lg={6} md={6} sm={6} xs={12}>
            <TextFieldErp
              disabled
              helperText={errors.numInscricao}
              error={errors.numInscricao ? true : false}
              value={numInscricao}
              onChange={(e) =>
                handleNumInscricao({
                  prop: e,
                  tipoInscricaoProp: tipoInscricao,
                })
              }
              label="N° Inscrição*"
            />
          </Grid>

          <Grid item lg={4} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.numInscricaoEstadual || ""}
              error={errors.numInscricaoEstadual ? true : false}
              value={numInscricaoEstadual}
              onChange={handleNumInscricaoEstadual}
              label="N° Inscrição Estadual"
            />
          </Grid>

          <Grid item lg={2} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.numInscricaoMunicipal || ""}
              error={errors.numInscricaoMunicipal ? true : false}
              value={numInscricaoMunicipal}
              onChange={handleNumInscricaoMunicipal}
              label="N° Inscrição Municipal"
            />
          </Grid>

          <Grid item lg={2} md={4} sm={4} xs={12}>
            <TextFieldErp
              helperText={errors.ccm || ""}
              error={errors.ccm ? true : false}
              value={ccm}
              onChange={handleCcm}
              label="CCM"
            />
          </Grid>

          <Grid item lg={8} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.nome || ""}
              error={errors.nome ? true : false}
              value={nome}
              onChange={handleNome}
              label="Nome do Estabelecimento*"
            />
          </Grid>

          <Grid item lg={4} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.email}
              error={errors.email ? true : false}
              value={email}
              onChange={handleEmail}
              label="E-mail Principal*"
            />
          </Grid>

          <Grid item flex={1}>
            <Grid
              item
              xs={9}
              container
              spacing={1}
              alignItems="center"
              justify="space-between"
            >
              <Grid item xs={12}>
                Certificado Digital
              </Grid>

              <Grid
                item
                container
                justify="center"
                className="container-checkbox"
                spacing={1}
              >
                <Grid
                  item
                  xs={6}
                  container
                  alignItems="center"
                  justify="center"
                >
                  <FormControlLabel
                    control={
                      <>
                        {loadingCheckbox ? (
                          <CircularLoader className="loading-check-cnd" />
                        ) : (
                          <Checkbox
                            checked={checkboxCertificado.contador}
                            onChange={handleChangeCheckContador}
                            name="contador"
                            color="primary"
                          />
                        )}
                      </>
                    }
                    label="Contador"
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  container
                  alignItems="center"
                  justify="center"
                >
                  <FormControlLabel
                    control={
                      <>
                        {loadingCheckbox ? (
                          <CircularLoader className="loading-check-customer" />
                        ) : (
                          <Checkbox
                            checked={checkboxCertificado.cliente}
                            onChange={handleChangeCheckCliente}
                            name="cliente"
                            color="primary"
                          />
                        )}
                      </>
                    }
                    label={
                      <Grid
                        container
                        alignItems="center"
                        justify="center"
                        spacing={1}
                      >
                        <Grid item xs={7}>
                          Cliente
                        </Grid>

                        <Grid item xs={5}>
                          <CloudUploadIcon className="icon-cloud" />
                        </Grid>
                      </Grid>
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}

function TabEndereco({ row }) {
  const [optionsFilterMunicipio, setOptionsFilterMunicipio] = useState([]);
  const {
    handlePais,
    handleCep,
    handleUf,
    handleCidade,
    handleLogradouro,
    handleComplemento,
    handleBairro,
  } = useClienteController();
  const { pais, cep, uf, cidade, logradouro, complemento, bairro, errors } =
    useContext(ClienteContext);
  const {
    optionsPais,
    optionsEstado,
    optionsMunicipio,
    loadingInputsImutaveis,
  } = useContext(ImutaveisContext);

  useEffect(() => {
    setOptionsFilterMunicipio(optionsMunicipio);
  }, [optionsMunicipio]);

  useEffect(() => {
    if (row) {
      const newRow = JSON.parse(row);
      handleCidade(
        optionsMunicipio.find(
          (opt) => opt.codigo === newRow.municipio_codigo
        ) || null
      );
    }

    setOptionsFilterMunicipio(
      uf
        ? optionsMunicipio.filter((opt) => opt.estado_codigo === uf.codibge)
        : optionsMunicipio
    );
  }, [uf, handleCidade, optionsMunicipio, row]);

  return (
    <>
      <Grid
        container
        style={{
          background: "white",
          borderRadius: "10px 10px 0px 0px",
          padding: 10,
        }}
      >
        <Grid container spacing={2}>
          <Grid item lg={9} md={9} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsPais || false}
              helperText={errors.pais || ""}
              error={errors.pais ? true : false}
              label="País*"
              value={pais}
              onChange={handlePais}
              optionsList={optionsPais}
              descriptionField="descricao"
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={6}>
            <TextFieldErp
              helperText={errors.cep || ""}
              error={errors.cep ? true : false}
              value={cep}
              onChange={handleCep}
              label="CEP*"
            />
          </Grid>

          <Grid item lg={4} md={4} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsEstado || false}
              helperText={errors.uf || ""}
              error={errors.uf ? true : false}
              label="UF*"
              value={uf}
              onChange={handleUf}
              optionsList={optionsEstado}
              descriptionField="nome"
            />
          </Grid>

          <Grid item lg={8} md={8} sm={6} xs={6}>
            <SelectErp
              loading={loadingInputsImutaveis.optionsMunicipio || false}
              helperText={errors.cidade || ""}
              error={errors.cidade ? true : false}
              label="Cidade*"
              value={cidade}
              onChange={handleCidade}
              optionsList={optionsFilterMunicipio}
              descriptionField="municipio"
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.logradouro || ""}
              error={errors.logradouro ? true : false}
              value={logradouro}
              onChange={handleLogradouro}
              label="Logradouro*"
            />
          </Grid>

          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.complemento || ""}
              error={errors.complemento ? true : false}
              value={complemento}
              onChange={handleComplemento}
              label="Complemento"
            />
          </Grid>

          <Grid item lg={12} md={12} sm={12} xs={12}>
            <TextFieldErp
              helperText={errors.bairro || ""}
              error={errors.bairro ? true : false}
              value={bairro}
              onChange={handleBairro}
              label="Bairro*"
            />
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
